<template>
    <div>
        <b-sidebar
            v-model="hover"
            id="sidebar-settings"
            :title="$t('sideBarSettings.title')">

            <div class="px-3 py-2" style="text-align: left; overflow: hidden;" v-if="dataIsLoaded">

                <div style="margin-top:20px">
                    <b>{{ $t('sideBarSettings.carac') }}</b>
                    <select v-model="selectedCarac" class="custom-select" style="margin-top:5px;">
                        <option 
                            v-for="(carac,index) in settings.caracs "
                            v-bind:key="index"
                            v-bind:value="carac"
                        >
                            {{$t(`caracs.${carac}.label`)}}
                        </option>
                    </select>
                </div>

                <div v-if="settings.mapTypes.length>1" style="margin-top:20px">
                    <b>{{ $t('sideBarSettings.mapType') }}</b>
                    <b-form-group>
                        <b-form-radio 
                            v-for="(mapType, index) in settings.mapTypes"
                            :key="index"
                            :value="mapType"
                            :name="mapType" 
                            v-model="selectedMapType">
                            {{ $t(`mapTypes.${mapType}`) }}
                        </b-form-radio>
                    </b-form-group>
                </div>

                <div class="row" style="margin-top:20px">
                    <div class="col-md-6">
                        <u><h5>{{ $t('sideBarSettings.case') }} 1</h5></u>
                        <br>
                        <div id="parcelSetter">
                            <b>{{ $t('sideBarSettings.parcel') }}</b>
                            <br>
                            <select v-model="selectedParcelNameG" class="custom-select">
                                <option
                                v-for="(parcelName, index) in settings.parcelNames"
                                :key="index"
                                :value="parcelName">{{ parcelName }}
                                </option>
                            </select>
                        </div>
                        <br>
                        <PhenoSelector id="phenoG" :leftSide="true"></PhenoSelector>
                        <br>
                        
                   
                    </div>
                    <div class="col-md-6">
                        <u><h5>{{ $t('sideBarSettings.case') }} 2</h5></u>
                        <br>
                        <div id="parcelSetter">
                            <b>{{ $t('sideBarSettings.parcel') }}</b>
                            <br>
                            <select v-model="selectedParcelNameD" class="custom-select">
                                <option
                                v-for="(parcelName, index) in settings.parcelNames"
                                v-bind:key="index"
                                v-bind:value="parcelName">{{ parcelName }}
                                </option>
                            </select>
                        </div>
                        <br> 
                        <PhenoSelector id="phenoD" v-bind:leftSide="false"></PhenoSelector>
                         <br>
                   
                    </div>  
                </div>
            </div>
        </b-sidebar>

        <div id="sidebar-trigger" 
            style="position: fixed;
            height: 100%;
            width: 30px;
            z-index: 999;
            background-color: #f8f9fa !important"
            >
            <b-icon icon="sliders" style="margin-top: 20px;"></b-icon>
        </div>
        
        <div id="content" class="row" style="margin: 0px 30px 0px 30px;">
            
            <div v-if="dataIsLoaded" class="col-md-12" style="padding-top:0px;">
              
                <div class="row" style="height: 50vh; margin-bottom: 50px;">
                    <div class="col-md-6">
                        <MapComponent id="parcelG" 
                        :carac="selectedCarac" 
                        :mapType="selectedMapType" 
                        :parcel="selectedParcelG" 
                        :sextiles="sextiles" 
                        :min="startLeft" 
                        :max="endLeft" 
                        :values="dataLeftFiltered" 
                    />
                    </div> 
                    <div class="col-md-6">
                        <MapComponent id="parcelD" 
                        :carac="selectedCarac" 
                        :mapType="selectedMapType" 
                        :parcel="selectedParcelD" 
                        :sextiles="sextiles" 
                        :min="startRight" 
                        :max="endRight" 
                        :values="dataRightFiltered" 
                    />
                    </div>
                </div>

                <p style="text-align:center; width:100%; margin:5px">
                    {{$t(`caracs.${selectedCarac}.label`)}}
                </p>

                <div class="row">
                    <div class="col-md-8" style="float:none;margin:auto;">
                        <LegendComponent id="legend" :carac="selectedCarac" :sextiles="sextiles"/>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-8" style="float:none;margin:auto;">
                        <b-button
                            v-model="chartLinked"
                            variant="light"
                            @click="chartLinked = !chartLinked">
                            <!--img v-if="chartLinked" src="/images/broken-link-32.svg" alt="" max-height="20" max-width="20"-->
                            <b-icon v-if="chartLinked" icon="link"></b-icon>
                            <b-icon v-else icon="link-45deg"></b-icon>
                            <span v-if="chartLinked" > {{$t(`chart.unlink`)}}</span>
                            <span v-else > {{$t(`chart.link`)}}</span>
                        </b-button>
                    </div>
                </div>
                
                <div class="row">
                    <div class="col-md-6">
                        <ChartComponent id="chartG" 
                            :precision="precision" 
                            :mapType="selectedMapType" 
                            :selectedCarac="selectedCarac" 
                            :sextiles="sextiles" 
                            :minXChart="minXChart" 
                            :maxXChart="maxXChart" 
                            :maxOccur="maxOccur" 
                            :values="chartLeft" 
                            :minThreshold="minThresholdLeft" 
                            :maxThreshold="maxThresholdLeft" 
                            :chartLinked="chartLinked"
                            v-on:chartFilter="handleChartFiltering"/>
                    </div> 
                    <div class="col-md-6">
                        <ChartComponent id="chartD" 
                            :precision="precision" 
                            :mapType="selectedMapType"
                            :selectedCarac="selectedCarac" 
                            :sextiles="sextiles" 
                            :minXChart="minXChart" 
                            :maxXChart="maxXChart" 
                            :maxOccur="maxOccur" 
                            :values="chartRight" 
                            :minThreshold="minThresholdRight" 
                            :maxThreshold="maxThresholdRight"
                            :chartLinked="chartLinked"
                            v-on:chartFilter="handleChartFiltering"/>
                    </div>
                </div>

                <div class="row" style="margin-bottom:20px; height: 15vh;">
                    <div class="col-md-4 offset-md-1">
                        <StatsComponent id="statsG" :carac="selectedCarac" :precision="precision" :parcel="selectedParcelG" :values="statsLeft" :recupValues="[]"></StatsComponent>
                    </div> 
                    <div class="col-md-4 offset-md-2">
                        <StatsComponent id="statsD" :carac="selectedCarac" :precision="precision" :parcel="selectedParcelD" :values="statsRight" :recupValues="[]"></StatsComponent>
                    </div>
                </div>

            </div>
            
            <div v-else class="col-md-12" style="margin-top: 200px;">
                <h3>{{ $t('global.loading') }}</h3>
                <b-spinner label="Spinning"></b-spinner>
            </div>
             
        </div>
    </div>
    
</template>

<script>
import PhenoSelector from './components/PhenoSelector'
import LegendComponent from './components/LegendComponent'
import MapComponent from './components/MapComponent'
import ChartComponent from './components/ChartComponent'
import StatsComponent from './components/StatsComponent'
import ParcelUtils from "./composables/ParcelUtils.js"
import * as helpers from './helpers.js'

export default {
    name: 'InterParcel',
    components:{
        PhenoSelector,
        LegendComponent,
        MapComponent,
        ChartComponent,
        StatsComponent
    },

    data() {
    return {
        selectedParcelNameG: null,
        selectedParcelNameD: null,
        selectedMapType: null,
        selectedCarac: null,
        startValueG: null,
        endValueG: null,
        startValueD: null,
        endValueD: null,
        hover: false,
        chartLinked:false
        }
    },

    mounted() {
        if (this.dataIsLoaded) this.setDefault()

        document.querySelector("#sidebar-trigger").addEventListener("mouseenter", (e) => {
            this.hover = true;
        });
        document.querySelector("#content").addEventListener("mouseenter", (e) => {
            if (this.hover)
                this.hover = false;
        });
    },

    computed:{
        dataIsLoaded(){
            return this.$store.getters.getDataIsLoaded
        },
        settings(){
            return this.$store.state.settings
        },
        allDataWithoutOutlayers(){
            return [...this.dataLeftWithoutOutlayers, ...this.dataRightWithoutOutlayers];
        },
        selectedParcelG(){
            return this.$store.getters.getSelectedParcelG
        },
        selectedParcelD(){
            return this.$store.getters.getSelectedParcelD
        },
        chartLeft(){
            return this.getChart(this.dataLeft);
        },

        chartRight(){
            return this.getChart(this.dataRight);
        },
        minXChart(){
            if (!this.chartLinked) return this.minThresholdLeft
            return Math.min(Math.min(...this.chartLeft), Math.min(...this.chartRight));
        },
        maxXChart(){
            if (!this.chartLinked) return this.maxThresholdLeft
            return Math.max(Math.max(...this.chartLeft), Math.max(...this.chartRight));
        },
        maxOccurRight() {
            let maxOccur = 0;
            const freq = {};
            const values = this.chartRight.map(v => v.toFixed(this.precision));
            for (const num of values) {
                freq[num] = (freq[num] || 0) + 1;
                if (freq[num] > maxOccur) {
                    maxOccur = freq[num];
                }
            }
            return maxOccur / this.chartRight.length * 100
        },
        maxOccurLeft() {
            let maxOccur = 0;
            const freq = {};
            const values = this.chartLeft.map(v => v.toFixed(this.precision));
            for (const num of values) {
                freq[num] = (freq[num] || 0) + 1;
                if (freq[num] > maxOccur) {
                    maxOccur = freq[num];
                }
            }
            return maxOccur / this.chartLeft.length * 100
        },
        maxOccur() {
            if (!this.chartLinked) return null
            if (this.selectedCarac === 'lwa') {
                return Math.max(this.maxOccurRight, this.maxOccurLeft)*10;
            }
            return Math.max(this.maxOccurRight, this.maxOccurLeft);
        },
        dataLeft (){
            return this.getData(this.selectedParcelG)
        },

        dataRight(){
            return this.getData(this.selectedParcelD)
        },

        dataLeftWithoutOutlayers(){
            if (this.selectedMapType == "rawMap"){
                return ParcelUtils.removeOutlayersData(this.dataLeft, this.selectedCarac);
            } else {
                return this.dataLeft;
            }
        },

        dataRightWithoutOutlayers(){
            if (this.selectedMapType == "rawMap"){
                return ParcelUtils.removeOutlayersData(this.dataRight, this.selectedCarac);
            } else {
                return this.dataRight;
            }
        },

        dataLeftFiltered(){
            return this.getDataFiltered(this.dataLeft, this.startLeft, this.endLeft)
        },

        dataRightFiltered(){
            return this.getDataFiltered(this.dataRight, this.startRight, this.endRight)
        },

        endLeft(){
            return Math.min(this.maxThresholdLeft, this.endValueG)
        },

        endRight(){
            return Math.min(this.maxThresholdRight, this.endValueD)
        },

        startLeft(){
            return Math.max(this.minThresholdLeft, this.startValueG)
        },

        startRight(){
            return Math.max(this.minThresholdRight, this.startValueD)
        },

        minThresholdLeft(){
            return this.getMinThreshold(this.dataLeftWithoutOutlayers)
        },

        minThresholdRight(){
            return this.getMinThreshold(this.dataRightWithoutOutlayers)
        },

        maxThresholdLeft(){
            return this.getMaxThreshold(this.dataLeftWithoutOutlayers)
        },

        maxThresholdRight(){
            return this.getMaxThreshold(this.dataRightWithoutOutlayers)
        },

        precision(){
            return helpers.getPrecision(this.selectedCarac, this.selectedMapType);
        },

        statsLeft(){
            return this.getStats(this.dataLeftFiltered);
        },

        statsRight(){
            return this.getStats(this.dataRightFiltered);
        },

        sextiles(){
            if (this.selectedParcelG != null && this.selectedParcelD != null){
                let sixtils = [.1667, .3333, .5, .6667, .8333]
                let values
                if (this.selectedMapType == "rawMap")
                    values = ParcelUtils.getPercentilValues(ParcelUtils.asc(this.allDataWithoutOutlayers.map(f => f.properties[this.selectedCarac])), sixtils)
                else
                    values = ParcelUtils.getPercentilValues(ParcelUtils.asc(this.allDataWithoutOutlayers), sixtils)
                return values
            }
            else {
                return []
            }
        },
    },
    methods: {
        setDefault(){
            this.selectedParcelNameG = this.$store.state.selectedParcelNameG
            this.selectedParcelNameD = this.$store.state.selectedParcelNameD
            this.selectedMapType = this.$store.state.selectedMapType
            this.selectedCarac = this.$store.state.selectedCarac
        },
        getData(parcel){
            console.log('getData', parcel, this.selectedCarac)
            if (parcel == null || !this.selectedCarac)
                return []
            // HACK density to purcent
            if (this.selectedCarac==="tfi"
                && parcel.geojson.features[0].properties.tfi < 1.2
            ) {
                parcel.geojson.features = parcel.geojson.features.map(f=> {f.properties.tfi = f.properties.tfi *100;return f})
            }
            if (this.selectedMapType == "rawMap"){
                return ParcelUtils.sortByCarac(parcel.geojson.features, this.selectedCarac);
            } else {
                console.log('tif',this.selectedCarac, parcel.tiff[this.selectedCarac])
                if (!parcel.tiff[this.selectedCarac]) return []
                
                let values = parcel.tiff[this.selectedCarac].values[0];
                values = values.map(a => [...a]).flat().filter(v => !isNaN(v));
                // HACK density to purcent
                if (this.selectedCarac === "tfi") {
                    values = values.map(v=> {v=v *100;return v})
                }
                return ParcelUtils.asc(values);
            }
        },

        getDataFiltered(arrayData, min, max){
            if (arrayData.length == 0)
                return [];
            if (this.selectedMapType == "rawMap")
                return arrayData.filter(f => f.properties[this.selectedCarac] >= min && f.properties[this.selectedCarac] <= max);
            else
                return arrayData.filter(v => v >= min && v <= max);
        },

        getChart(arrayData){
            if (this.selectedMapType == "rawMap")
                return arrayData.map(f => f.properties[this.selectedCarac]) 
            else 
                return arrayData
        },

        getMaxThreshold(arrayData){
            if (arrayData.length == 0)
                return null;
            if (this.selectedMapType == "rawMap")
                return arrayData[arrayData.length -1].properties[this.selectedCarac];
            else
                return arrayData[arrayData.length -1];
        },

        getMinThreshold(arrayData){
            if (arrayData.length == 0)
                return null;
            if (this.selectedMapType == "rawMap")
                return arrayData[0].properties[this.selectedCarac];
            else
                return arrayData[0];
        },

        getStats(arrayData){
            if (this.selectedMapType == "rawMap")
                return arrayData.map(f => f.properties[this.selectedCarac])
            else
                return arrayData
        },

        handleChartFiltering({id, start, end}) {
            if (id == 'chartG') {
                this.startValueG = start;
                this.endValueG = end;
            } else if (id == 'chartD') {
                this.startValueD = start;
                this.endValueD = end;
            }
        },
    },

    watch: {
        selectedParcelNameG : function(val){
            this.$store.commit("setSelectedParcelNameG", val);
        },

        selectedParcelNameD : function(val){
            this.$store.commit("setSelectedParcelNameD", val);
        },
        dataIsLoaded: function(val){
            if (val) this.setDefault()
        }
    }
}

</script>

<style>

</style>
    
    